module.exports = "/images/45fe40429c8e874caba3020e322bf2af.svg";